const staffList = state => state.staffList

const healthCareTeamList = state => state.healthCareTeamList

const categoryList = state => state.categoryList

const statuses = state => state.statuses

const loading = state => state.loading

const healthEvents = state => state.healthEvents

const sortBy = state => state.sortBy

const sortOrder = state => state.sortOrder

const stopLoad = state => state.stopLoad

const filters = state => state.filters

const currentEvent = state => state.currentEvent

const followUpData = state => state.followUpData

const plannedFollowUps = state => {
  const plannedFollowUps = [...state.plannedFollowUps]

  return plannedFollowUps.sort((a, b) => {
    const aTime = a.dueDate
    const bTime = b.dueDate

    if (aTime > bTime) return 1
    else if (aTime < bTime) return -1
    return 0
  })
}

export default {
  staffList,
  healthCareTeamList,
  categoryList,
  statuses,
  healthEvents,
  loading,
  sortBy,
  sortOrder,
  stopLoad,
  filters,
  currentEvent,
  followUpData,
  plannedFollowUps
}
